export default {
  appliances: {
    categories: [
      { id: 'wholeHouse', label: 'Whole <br class="hidden-xs-up" />House' },
      { id: 'essentials', label: 'Just the <br class="hidden-xs-up" />Essentials' },
    ],
    fields: [
      {
        group: 'Home Essentials',
        label: 'Central Air Conditioner',
        type: 'numeric',
        watts: 3500,
        categories: ['essentials', 'wholeHouse'],
        preselect: ['essentials', 'wholeHouse'],
        excludeFromPartialUse: true,
      },
      {
        group: 'Home Essentials',
        label: 'Electric Water Heater',
        type: 'numeric',
        watts: 4500,
        categories: ['essentials', 'wholeHouse'],
        preselect: ['essentials', 'wholeHouse'],
      },
      {
        group: 'Home Essentials',
        label: 'Gas Furnace',
        type: 'numeric',
        watts: 800,
        categories: ['essentials', 'wholeHouse'],
        preselect: ['essentials', 'wholeHouse'],
      },
      {
        group: 'Home Essentials',
        label: 'Electric Garage Door',
        type: 'numeric',
        watts: 350,
        categories: ['essentials', 'wholeHouse'],
        preselect: ['essentials', 'wholeHouse'],
      },
      {
        group: 'Home Essentials',
        label: 'Sump Pump',
        type: 'numeric',
        watts: 1100,
        categories: ['wholeHouse'],
        preselect: [],
      },
      {
        group: 'Home Essentials',
        label: 'Well Pump',
        type: 'numeric',
        watts: 1100,
        categories: ['wholeHouse'],
        preselect: [],
      },
      {
        group: 'Family Essentials',
        label: 'Refrigerator',
        type: 'numeric',
        watts: 1000,
        categories: ['essentials', 'wholeHouse'],
        preselect: ['essentials', 'wholeHouse'],
      },
      {
        group: 'Family Essentials',
        label: 'Freezer',
        type: 'numeric',
        watts: 500,
        categories: ['essentials', 'wholeHouse'],
        preselect: ['essentials', 'wholeHouse'],
      },
      {
        group: 'Family Essentials',
        label: 'Wall Oven or Range (electric)',
        type: 'numeric',
        watts: 4000,
        categories: ['wholeHouse'],
        preselect: ['wholeHouse'],
      },
      {
        group: 'Family Essentials',
        label: 'Cooktop (electric)',
        type: 'numeric',
        watts: 3500,
        categories: ['wholeHouse'],
        preselect: [],
      },
      {
        group: 'Family Essentials',
        label: 'Cooktop (gas)',
        type: 'numeric',
        watts: 350,
        categories: ['wholeHouse'],
        preselect: ['wholeHouse'],
      },
      {
        group: 'Family Essentials',
        label: 'Microwave',
        type: 'numeric',
        watts: 1200,
        categories: ['essentials', 'wholeHouse'],
        preselect: ['essentials', 'wholeHouse'],
      },
      {
        group: 'Family Essentials',
        label: 'Dishwasher',
        type: 'numeric',
        watts: 1250,
        categories: ['wholeHouse'],
        preselect: ['essentials', 'wholeHouse'],
      },
      {
        group: 'Family Essentials',
        label: 'Washer',
        type: 'numeric',
        watts: 700,
        categories: ['wholeHouse'],
        preselect: ['wholeHouse'],
      },
      {
        group: 'Family Essentials',
        label: 'Dryer (Electric)',
        type: 'numeric',
        watts: 5000,
        categories: ['wholeHouse'],
        preselect: ['wholeHouse'],
      },
      {
        group: 'Family Essentials',
        label: 'Dryer (Gas)',
        type: 'numeric',
        watts: 500,
        categories: ['wholeHouse'],
        preselect: [],
      },
      {
        group: 'Added Luxuries',
        label: 'Hot Tub',
        type: 'numeric',
        watts: 5500,
        categories: ['wholeHouse'],
        preselect: [],
      },
      {
        group: 'Added Luxuries',
        label: 'Sauna',
        type: 'numeric',
        watts: 4500,
        categories: ['wholeHouse'],
        preselect: [],
      },
      {
        group: 'Added Luxuries',
        label: 'Pool',
        type: 'numeric',
        watts: 2525,
        categories: ['wholeHouse'],
        preselect: [],
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/views/Home/components/configs/form-data-config.js